import {Menu} from './menu.model';

export const verticalMenuItems = [
  new Menu(1, 'Financial Dashboard', '/portal/dashboard', null, 'tachometer', null, false, 0),
  new Menu(8, 'Clients', null, null, 'user-o', null, true, 0),
  new Menu(9, 'Client', '/portal/client', null, 'user-o', null, false, 8),
  new Menu(31, 'Invoices', null, null, 'usd', null, true, 0),
  new Menu(32, 'Invoice Listing', '/portal/invoicelisting', null, 'usd', null, false, 31),
  new Menu(2, 'Processes', null, null, 'cogs', null, true, 0),
  new Menu(26, 'Invoice Assignment', '/portal/invoiceassignment', null, 'cogs', null, false, 2),
  new Menu(27, 'NOA', null, null, 'cogs', null, true, 2),
  new Menu(33, 'NOA Followup', '/portal/noafollowup', null, 'cogs', null, false, 27),
  new Menu(34, 'NOA Client Exceptions', '/portal/noaclientexceptions', null, 'cogs', null, false, 27),
  new Menu(4, 'IT', null, null, 'desktop', null, true, 0),
  new Menu(23, 'User Admin', '/portal/useradmin', null, 'user', null, false, 4),
  new Menu(24, 'Participants', '/portal/itparticipants', null, 'user', null, false, 4),
  new Menu(25, 'Participation Profiles', '/portal/itparticipantsprofiles', null, 'user', null, false, 4),
  new Menu(37, 'Marketing Partners', '/portal/itmarketingpartners', null, 'user', null, false, 4),
  new Menu(42, 'Sales Offices', '/portal/salesoffices', null, 'user', null, false, 4),
  new Menu(6, 'Reports', null, null, 'line-chart', null, true, 0),
  new Menu(7, 'Participation Amount Exceptions', '/portal/participationamountexceptions', null, 'line-chart', null, false, 6),
  new Menu(7, 'Payment Details', '/portal/payments', null, 'line-chart', null, false, 6),
  new Menu(28, 'Fee Pct', '/portal/feepct', null, 'line-chart', null, false, 6),
  new Menu(29, 'Payments by Week', '/portal/paymentsbyweek', null, 'line-chart', null, false, 6),
  new Menu(30, 'Checks by Day', '/portal/checksbyday', null, 'line-chart', null, false, 6),
  new Menu(35, 'Notifications', null, null, 'bell', null, true, 0),
  new Menu(36, 'Pending Notifications', '/portal/notifications/pending', null, 'bell', null, false, 35),
  new Menu(38, 'Approved Notifications', '/portal/notifications/approved', null, 'bell', null, false, 35),
  new Menu(39, 'Rejected Notifications', '/portal/notifications/rejected', null, 'bell', null, false, 35),
  new Menu(10, 'Aging Reports', null, null, 'line-chart', null, true, 6),
  new Menu(11, 'Aging By Client 10', '/portal/reports/aging/client-10', null, 'line-chart', null, false, 10),
  new Menu(12, 'Aging By Client 30', '/portal/reports/aging/client-20', null, 'line-chart', null, false, 10),
  new Menu(13, 'Aging By Participant 30', '/portal/reports/aging/participant-30', null, 'line-chart', null, false, 10),
  new Menu(13, 'Aging By Account Exec', '/portal/reports/aging/by-account-exec', null, 'line-chart', null, false, 10),
  new Menu(14, 'Aging By Vintage', '/portal/reports/aging/vintage', null, 'line-chart', null, false, 10),
  new Menu(15, 'Detailed Breakdown 30', '/portal/reports/aging/breakdown-30', null, 'line-chart', null, false, 10),
  new Menu(16, 'Participant Reports', null, null, 'line-chart', null, true, 6),
  new Menu(17, 'Payment Details', '/portal/reports/participant/payment-details', null, 'line-chart', null, false, 16),
  new Menu(18, 'Invoice Details', '/portal/reports/participant/invoice-details', null, 'line-chart', null, false, 16),
  new Menu(19, 'Purchases', null, null, 'line-chart', null, true, 6),
  new Menu(20, 'Purchases By Week', '/portal/purchases-by-week', null, 'line-chart', null, false, 19),
  new Menu(21, 'Purchases By Client', '/portal/purchases-by-client', null, 'line-chart', null, false, 19),
  new Menu(22, 'Purchases By Vintage', '/portal/purchases-by-vintage', null, 'line-chart', null, false, 19),
  new Menu(23, 'Aging By Account Exec', '/portal/reports/aging/by-account-exec', null, 'line-chart', null, false, 10),
  new Menu(24, 'New Client By Vintage', '/portal/newclientsbyvintage', null, 'line-chart', null, false, 6),
];

export const horizontalMenuItems = [
  new Menu(1, 'Dashboard', '/portal/dashboard', null, 'tachometer', null, false, 0),
  new Menu(8, 'Clients', null, null, 'line-chart', null, true, 0),
  new Menu(9, 'Client', '/portal/client', null, 'line-chart', null, false, 8),
  new Menu(2, 'Processes', null, null, 'line-chart', null, true, 0),
  new Menu(4, 'It', null, null, 'desktop', null, true, 0),
  new Menu(35, 'Notifications', null, null, 'bell', null, true, 0),
  new Menu(36, 'Pending', '/portal/notifications/pending', null, 'bell', null, false, 35),
  new Menu(38, 'Approved', '/portal/notifications/approved', null, 'bell', null, false, 35),
  new Menu(39, 'Rejected', '/portal/notifications/rejected', null, 'bell', null, false, 35),
  new Menu(6, 'Reports', null, null, 'line-chart', null, true, 0),
  new Menu(7, 'Payment Details', '/portal/payments', null, 'line-chart', null, false, 6),
];



// WEBPACK FOOTER //
// ./src/app/core/components/menu/menu.ts